import { properties } from "@repoflow/common/schema-fields";
import {
  keyId,
  description,
  keySecret,
  roles,
  ownerId,
  ownerOrgId,
  resourceType,
  scope,
  rateLimit
} from "@common/schema/keys/fields";

export default [
  {
    id: "/Public/Key",
    type: "object",
    properties: {
      ...properties,
      keyId,
      description,
      keySecret,
      roles,
      ownerId,
      ownerOrgId,
      resourceType,
      scope,
      rateLimit
    },
  },
  {
    id: "/Public/Key/Create",
    type: "object",
    properties: {
      roles,
      description,
      scope
    },
  },
];
